/* eslint-disable import/prefer-default-export,react/forbid-prop-types */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { getCardCapabilities } from '../../../../screens/Card/constants';
import { formatNumberWithComma } from '../../../../utilities/formatHelpers';
import { CardLogo } from '../CardLogo';

export const FallbackCard = ({
  cardProvider,
  cardNetwork,
  amount,
  currency,
  displayedCardCurrency,
}) => {
  const amountRef = useRef();
  const [currencyXCoordinate, setCurrencyXCoordinate] = useState(-100);

  const calculatePositions = () => {
    if (amountRef.current) {
      setCurrencyXCoordinate(25 + amountRef.current.getComputedTextLength());
    }
  };

  useEffect(() => {
    setTimeout(calculatePositions, 500);
  }, [amount, currency]);

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 370 218"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="370" height="218" rx="12" fill="black" />
      <rect
        opacity="0.6"
        x="0.5"
        y="0.5"
        width="369"
        height="217"
        rx="11.5"
        fill="url(#paint0_linear_19084_153888)"
        stroke="url(#paint1_linear_19084_153888)"
      />
      <CardLogo cardNetwork={cardNetwork?.toUpperCase()} cardProvider={cardProvider} />

      {/* Hide balance for non active monavate card (DV-4467) */}
      {!getCardCapabilities(cardProvider).hidesInactiveCardBalance && (
        <g>
          <text ref={amountRef} fill="white" fontWeight="bold" fontSize="34" x="20" y="130">
            {formatNumberWithComma(amount)}
          </text>
          <text x={currencyXCoordinate} y="130" fontWeight={600} fill="#646564" fontSize="17">
            {displayedCardCurrency}
          </text>
        </g>
      )}

      <defs>
        <linearGradient
          id="paint0_linear_19084_153888"
          x1="370"
          y1="0.24809"
          x2="292.961"
          y2="280.088"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="0.390033" stopColor="white" stopOpacity="0.33" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19084_153888"
          x1="-7.18182e-07"
          y1="100"
          x2="370"
          y2="102.5"
          gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopColor="white" stopOpacity="0.6" />
        </linearGradient>
        <clipPath id="clip0_19084_153888">
          <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
        </clipPath>
        <clipPath id="clip1_19084_153888">
          <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
        </clipPath>
      </defs>
    </svg>
  );
};

FallbackCard.propTypes = {
  cardProvider: PropTypes.string,
  amount: PropTypes.string,
  cardNetwork: PropTypes.string,
  currency: PropTypes.string,
  displayedCardCurrency: PropTypes.string,
};

FallbackCard.defaultProps = {
  cardProvider: null,
  amount: 0,
  currency: '',
  cardNetwork: '',
  displayedCardCurrency: '',
};
